import { type Avatar, type AvatarList, AvatarSchema } from "@storyline/shared";
import { env } from "@/src/common/constants/env";
import { unwrap } from "@/src/common/services/api-error";
import { putBinary } from "@/src/common/services/binary-upload.service";
import { httpClient, request } from "@/src/common/services/http.service";

export const fetchAvatars = async (): Promise<AvatarList> => unwrap(await request(() => httpClient.avatars.get()));

export const uploadAvatarBinary = async (file: File): Promise<Avatar> => {
	const response = await putBinary(`${env.SERVER_URL}/admin/avatars`, file);
	return AvatarSchema.parse(await response.json());
};

export const deleteAvatar = async (avatarId: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.avatars({ avatarId }).delete()));
};
